// Import model
import { ContactAssignment } from '../models/ContactAssignment';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Contact } from '../models/Contact';

// Import dependency serializers (for complex types)
import { ContactSerializer } from './ContactSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactAssignment - handles JSON serialization and deserialization with type validation
 */
export class ContactAssignmentSerializer {
  /**
   * Deserializes a JSON string into a ContactAssignment instance
   */
  static deserialize(json: string): ContactAssignment {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactAssignment instance
   */
  static fromObject(obj: any): ContactAssignment {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactAssignment');
    }


    const instance: ContactAssignment = {
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      name: obj['name'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      creatorIdName: obj['creatorId|Name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      contactId: obj['contactId'] as string | undefined,
      contactIdName: obj['contactId|Name'] as string | undefined,
      role: obj['role'] as string | undefined,
      contact: obj['contact'] ? ContactSerializer.fromObject(obj['contact']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactAssignment instances
   */
  static deserializeArray(json: string): ContactAssignment[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactAssignment instance to a JSON string
   */
  static serialize(instance: ContactAssignment): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactAssignment instance to a plain object
   */
  static toObject(instance: ContactAssignment): any {
    return {
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      'name': instance.name,
      'creatorId': instance.creatorId,
      'creatorId|Name': instance.creatorIdName,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'parentObjectId': instance.parentObjectId,
      'parentObjectType': instance.parentObjectType,
      'contactId': instance.contactId,
      'contactId|Name': instance.contactIdName,
      'role': instance.role,
      'contact': instance.contact ? ContactSerializer.toObject(instance.contact) : undefined,
    };
  }

  /**
   * Serializes an array of ContactAssignment instances to a JSON string
   */
  static serializeArray(instances: ContactAssignment[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
